import React from "react";
import { Container, Row } from "react-bootstrap";
import { PrismicRichText } from "@prismicio/react";
import Anchor from "../elements/Anchor";

import "../../styles/components/slices/title_text_buttons.scss";

const TitleTextButtons = ({ slice }) => {
  if (!slice) return null;
  const data = { ...slice };

  return (
    <Container
      fluid
      style={{
        backgroundImage: `url(${data.primary.background_image.gatsbyImageData.images.fallback.src})`,
        backgroundSize: "cover",
      }}
    >
      <Container className="p-92 title-text-buttons max-container justify-content-center">
        <Row className="text-center">
          <div className="title-65 text-white mb-5">
            {data.primary.title1.text}
          </div>
        </Row>
        <Row className="text-center text-white mb-4">
          <PrismicRichText field={data.primary.description.richText} />
        </Row>
        <Row className="justify-content-center flex-column flex-md-row align-items-center mb-1">
          {data.items.map((btn, index) => (
            <div
              className="book-now-outline me-md-3 mb-3 mb-md-0 mona"
              key={index}
            >
              <Anchor
                href={btn.link.url}
                className="book-now-btn text-center text-white"
                target={btn.link.target}
              >
                {btn.button_label}
              </Anchor>
            </div>
          ))}
        </Row>
      </Container>
    </Container>
  );
};

export default TitleTextButtons;
